import { ProductResult } from '@shared/api/types';
import { Icons } from '@shared/components/content/icons';
import Text from '@shared/components/content/text';
import ProductProcessingTable from './product-processing-table';

interface ProductDetailProcessingSectionProps {
  product: ProductResult;
  globalMaxEmissions: number;
}

export default function ProductDetailProcessingSection({
  product,
  globalMaxEmissions,
}: ProductDetailProcessingSectionProps) {
  const { processing } = product;

  if (product.totalEmissions == null || !processing.processingTypes?.length)
    return null;

  const share = (processing.processingEmissions / product.totalEmissions) * 100;

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <Text variant="cardTitle" className="text-primary-900">
            Processing
          </Text>
        </div>
        <div className="flex space-x-6">
          <span className="flex items-center space-x-1 text-right font-medium text-teal-600">
            <Icons.pieChart size={16} />
            <Text>{share.toFixed(1)}% of total emissions</Text>
          </span>
        </div>
      </div>
      <ProductProcessingTable
        processingTypes={processing.processingTypes || []}
        maxEmissions={globalMaxEmissions}
        totalEmissions={product.totalEmissions!}
        product={product.name}
      />
    </div>
  );
}
